export const STEPPER_STEPS = [
  "Mapping",
  "Extraction",
  "Validation",
  "Approval",
  "Submitted",
];
